// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"be","message":"bf","header":"bh","subHeading":"bi","buttons":"bj","buttonWrapper":"bk","btn":"bl"};